function VictimRiskLevel() {
    "use strict";
    this.Id = -1;
    this._type = 'VictimRiskLevel:www.veritracks.com';
    this.Version = 0;
    this.VictimRiskLevelId = -1;
    this.VictimRiskLevelName = -1;
}
if (typeof exports !== 'undefined') {
    module.exports = VictimRiskLevel;
}